(function ($) {
    const $form = $('#offer-form');

    if ($form.length === 0) {
        return;
    }

    const loadSubpreparations = (schoolYearId, brandId) => {
        const $container = $('#selected_sub_preparations');
        const url = $container.attr('data-ajax-url') + '/' + brandId + '/' + schoolYearId;

        $container.load(url, () => setDefaultSellDate());
    };

    const setDefaultSellDate = () => {
        $('#sub_preparation_id').change(function () {
            const $self = $(this);
            const $selectedOption = $self.find('option:selected');
            const $openDate = $('#open_date');
            const $closeDate = $('#close_date');
            const startDate = $selectedOption.attr('data-start-date-publication');
            const endDate = $selectedOption.attr('data-end-date-publication');

            if($openDate.val() === '') {
                $openDate.val(startDate);
            }
            if($closeDate.val() === '') {
                $closeDate.val(endDate);
            }
        });
    };

    const handleSubpreparationSelector = () => {
        $('#brand_id, #school_year_id').change(function () {
            const schoolYearId = $('#school_year_id').val();
            const brandId = $('#brand_id').val();

            if (brandId === '' || schoolYearId === '') {
                return;
            }

            loadSubpreparations(schoolYearId, brandId);
        });
    };

    const handleEditModulesModal = () => {
        $('.edit-modules').click(function () {
            const $modalBody = $('#module-body');
            const offerId = $(this).data('id');
            const offerTitle = 'Gestion de modules';
            const url = $modalBody.attr('data-ajax-url') + '/' + offerId + '/create';

            $('#module-title').html(offerTitle);
            $('#offer_id').attr('value', offerId);
            $modalBody.html('').load(url, function () {
                $modalBody.find('textarea:visible').summernote();
            });
        });

        $('.modal').on('hidden.bs.modal', function(){
            $('.modal-body').html('');
            $('#module-body').html('');
        });
    };

    handleSubpreparationSelector();
    handleEditModulesModal();

})($);
